(function () {
  if (window.FJBCContactForms) return;
  window.FJBCContactForms = true;

  var DRAFT_PREFIX = 'fjbc:contact-draft:v1:';
  var LAST_PREFIX = 'fjbc:contact-last:v1:';
  /* Set when this browser submits a valid form, keyed by the form id, and read once on the next
     load of that form. The confirmation popup needs it as well as Shopify's success render. */
  var SENT_PREFIX = 'fjbc:contact-sent:v1:';
  var SENT_MAX_AGE = 30 * 60 * 1000;

  function storage() {
    try {
      var test = DRAFT_PREFIX + 'test';
      window.sessionStorage.setItem(test, '1');
      window.sessionStorage.removeItem(test);
      return window.sessionStorage;
    } catch (error) {
      return null;
    }
  }

  function contextKey(wrapper) {
    var params = new URLSearchParams(window.location.search);
    var kind = wrapper.getAttribute('data-form-kind') || 'contact';
    var parts = [
      kind,
      'item=' + (params.get('item') || '').trim(),
      'service=' + (params.get('service') || '').trim(),
      'intent=' + (params.get('intent') || '').trim()
    ];
    return DRAFT_PREFIX + parts.map(encodeURIComponent).join(':');
  }

  /* Draft identity: the field name, or data-draft-key for a control that loses its name (the
     appointment grid's tick boxes). The joined "Preferred times" line is rebuilt, never stored. */
  function draftKey(control) {
    return control.getAttribute('data-draft-key') || control.name;
  }

  function controls(form) {
    return Array.prototype.filter.call(form.elements, function (control) {
      if (control.hasAttribute('data-availability-summary')) return false;
      if (control.hasAttribute('data-campaign-field')) return false;
      if (control.hasAttribute('data-time-zone-field')) return false;
      /* Photographs never enter the draft: the file input and the contact[Photos] line. */
      if (control.hasAttribute('data-photo-field')) return false;
      return control.hasAttribute('data-draft-key') || (control.name && control.name.indexOf('contact[') === 0);
    });
  }

  /* Preferred days and times. Without JavaScript every ticked box posts as its own field. With it,
     the boxes stop posting and one "Preferred times" field carries every choice in grid order, one
     choice per line (Eli, 2026-09-16, after the first real email showed them as one long list):
     "Monday 2pm to 6pm" newline "Friday 10am to 12pm". Sent only when a box is ticked. */
  function setupAvailability(form) {
    var summary = form.querySelector('[data-availability-summary]');
    if (!summary) return function () {};
    var boxes = Array.prototype.slice.call(form.querySelectorAll('[data-slot-label]'));
    boxes.forEach(function (box) { box.removeAttribute('name'); });
    function update() {
      var chosen = boxes.filter(function (box) { return box.checked; }).map(function (box) {
        return box.getAttribute('data-slot-label');
      });
      summary.value = chosen.join('\n');
      summary.disabled = chosen.length === 0;
    }
    form.addEventListener('change', update);
    update();
    return update;
  }

  function snapshot(form) {
    return controls(form).map(function (control) {
      return {
        name: draftKey(control),
        type: control.type,
        value: control.value,
        checked: Boolean(control.checked)
      };
    });
  }

  function saveDraft(store, key, form) {
    if (!store) return;
    try {
      store.setItem(key, JSON.stringify(snapshot(form)));
    } catch (error) {
      /* A full or unavailable session store must never block the contact form. */
    }
  }

  function restoreDraft(store, key, form) {
    if (!store) return;
    var saved;
    try {
      saved = JSON.parse(store.getItem(key) || 'null');
    } catch (error) {
      saved = null;
    }
    if (!Array.isArray(saved)) return;

    saved.forEach(function (entry) {
      var matches = controls(form).filter(function (control) {
        return draftKey(control) === entry.name;
      });
      matches.forEach(function (control) {
        if (control.type === 'checkbox' || control.type === 'radio') {
          if (!control.checked && entry.checked) control.checked = true;
          return;
        }
        if (!control.value && entry.value) control.value = entry.value;
      });
    });
  }

  function clearDraft(store, key, kind) {
    if (!store) return;
    try {
      store.removeItem(key);
      var lastKey = store.getItem(LAST_PREFIX + kind);
      if (lastKey) store.removeItem(lastKey);
      store.removeItem(LAST_PREFIX + kind);
    } catch (error) {
      /* A storage failure cannot change the server-confirmed success state. */
    }
  }

  function markSent(store, formId) {
    if (!store || !formId) return;
    try {
      store.setItem(SENT_PREFIX + formId, String(Date.now()));
    } catch (error) {
      /* Without the mark the success line under the form stays the confirmation. */
    }
  }

  /* Read and remove on every load, so a mark is used at most once. */
  function takeSentMark(store, formId) {
    if (!store || !formId) return false;
    try {
      var sentAt = Number(store.getItem(SENT_PREFIX + formId)) || 0;
      store.removeItem(SENT_PREFIX + formId);
      var age = Date.now() - sentAt;
      return sentAt > 0 && age >= 0 && age < SENT_MAX_AGE;
    } catch (error) {
      return false;
    }
  }

  function openSentDialog(dialog, result) {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    function close() {
      if (dialog.open) dialog.close();
    }
    dialog.querySelectorAll('[data-form-sent-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    /* A click on the scrim lands on the dialog itself; the panel fills the dialog box. */
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });
    /* Escape closes natively. Focus returns to the success line under the form. */
    dialog.addEventListener('close', function () {
      if (result) result.focus();
    });
    try {
      dialog.showModal();
    } catch (error) {
      return false;
    }
    focusOnArrival(dialog);
    return true;
  }

  /* Shopify returns to the page with the form's anchor (#appointment, #enquiry, #visit). Once the
     page has loaded, Chrome applies that anchor and clears focus, because a form is not focusable.
     Anything focused on arrival is focused again after that. */
  function afterAnchor(callback) {
    function settle() {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(callback);
      });
    }
    if (document.readyState === 'complete') settle();
    else window.addEventListener('load', settle, { once: true });
  }

  function focusOnArrival(element) {
    if (!element) return;
    element.focus();
    afterAnchor(function () {
      var active = document.activeElement;
      if (element.isConnected && (!active || active === document.body)) element.focus();
    });
  }

  function setFeedback(wrapper, text, state) {
    var region = wrapper.querySelector('[data-form-feedback]');
    if (!region) return;
    region.textContent = '';
    var message = document.createElement('p');
    message.className = 'form-feedback form-feedback--' + state;
    message.textContent = text;
    region.appendChild(message);
  }

  function productPath(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle);
  }

  function chooseOption(select, text) {
    if (!select || select.value || !text) return;
    for (var i = 0; i < select.options.length; i += 1) {
      if (select.options[i].text === text) {
        select.selectedIndex = i;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function prefillEnquiry(wrapper) {
    if (wrapper.getAttribute('data-form-kind') !== 'enquiry') return;
    var params = new URLSearchParams(window.location.search);
    var handle = (params.get('item') || '').trim();
    if (!handle) return;

    var rawIntent = (params.get('intent') || '').trim();
    var intent = rawIntent || 'purchase';
    var options = {
      purchase: 'Purchase enquiry about an item',
      question: 'Question about an item',
      similar: 'Something similar to a sold item'
    };
    var reason = wrapper.querySelector('[data-enquiry-reason]');
    var reference = wrapper.querySelector('[data-enquiry-reference]');
    var body = wrapper.querySelector('[data-enquiry-body]');
    var path = productPath(handle);
    var publicUrl = window.location.origin + path;

    if (Object.prototype.hasOwnProperty.call(options, intent)) chooseOption(reason, options[intent]);

    fetch(path + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (product) {
        if (reference && !reference.value) {
          reference.value = product.title + ' - ' + publicUrl;
          reference.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (!body || body.value) return;
        var opening;
        if (intent === 'purchase') opening = 'I would like to enquire about purchasing ' + product.title + '.';
        else if (intent === 'question') opening = 'I have a question about ' + product.title + '.';
        else if (intent === 'similar') opening = 'I am looking for something similar to ' + product.title + '.';
        else opening = 'I am contacting you about ' + product.title + '.';
        body.value = opening + '\n' + publicUrl + '\n\n';
        body.dispatchEvent(new Event('input', { bubbles: true }));
      })
      .catch(function () {
        if (reference && !reference.value) {
          reference.value = publicUrl;
          reference.dispatchEvent(new Event('input', { bubbles: true }));
        }
        var guidance = wrapper.querySelector('[data-prefill-error]');
        if (guidance) guidance.hidden = false;
      });
  }

  /* contact[Time zone]: the city part of the browser's time zone, underscores as spaces
     (Asia/Jerusalem reads Jerusalem). Left out when the browser gives none. */
  function stampTimeZone(form) {
    var zone = '';
    try {
      zone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    } catch (error) {
      zone = '';
    }
    var city = String(zone).split('/').pop().replace(/_/g, ' ').trim();
    var input = form.querySelector('[data-time-zone-field]');
    if (!city) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'contact[Time zone]';
      input.setAttribute('data-time-zone-field', '');
      form.appendChild(input);
    }
    input.value = city;
  }

  function initForm(wrapper) {
    var form = wrapper.querySelector('form');
    if (!form) return;
    var store = storage();
    var key = contextKey(wrapper);
    var kind = wrapper.getAttribute('data-form-kind') || 'contact';
    var posted = wrapper.querySelector('[data-form-posted]');
    var successful = posted && posted.getAttribute('data-form-posted') === 'true';
    var result = wrapper.querySelector('[data-form-result]');
    var formId = form.getAttribute('id');
    var sentHere = takeSentMark(store, formId);
    var updateAvailability = setupAvailability(form);

    if (successful) {
      clearDraft(store, key, kind);
      var opened = sentHere && openSentDialog(wrapper.querySelector('[data-form-sent]'), result);
      if (!opened) focusOnArrival(result);
    } else {
      restoreDraft(store, key, form);
      updateAvailability();
      focusOnArrival(result);
    }

    form.addEventListener('input', function () { saveDraft(store, key, form); });
    form.addEventListener('change', function () { saveDraft(store, key, form); });

    var pendingStarted = false;
    var pendingTimer = null;
    function startPending() {
      if (successful || pendingStarted || !form.checkValidity()) return;
      if (photosPending()) return;
      pendingStarted = true;
      if (store) {
        try { store.setItem(LAST_PREFIX + kind, key); } catch (error) { /* no-op */ }
      }
      markSent(store, formId);
      saveDraft(store, key, form);
      setFeedback(wrapper, wrapper.getAttribute('data-pending-message') || 'Sending your request...', 'pending');
      var delay = Number(wrapper.getAttribute('data-feedback-delay')) || 12000;
      pendingTimer = window.setTimeout(function () {
        setFeedback(wrapper, wrapper.getAttribute('data-unconfirmed-message') || 'We have not been able to confirm that your request was sent.', 'unconfirmed');
      }, delay);
    }

    form.addEventListener('submit', startPending);
    form.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('button[type="submit"], input[type="submit"]')) startPending();
    }, true);

    /* Photographs (assets/photo-upload.js, A38). While one is still on its way, Send is held with
       "Sending your photographs..." and a "Send without photographs" button; when they finish, or
       the visitor chooses, the contact[Photos] line is written and the form is submitted again
       through the browser, so hCaptcha and the sent popup run as usual. Listening on window in the
       capture phase puts this ahead of every other submit handler, Shopify's own included. Whatever
       happens to the photographs, the form still sends. */
    function photosPending() {
      return Boolean(form.fjbcPhotos && form.fjbcPhotos.pending());
    }

    var photoHold = null;
    function releasePhotoHold() {
      if (!photoHold) return;
      var submitter = photoHold.submitter;
      photoHold = null;
      form.fjbcPhotos.write();
      var region = wrapper.querySelector('[data-form-feedback]');
      if (region) region.textContent = '';
      startPending();
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter && submitter.form === form ? submitter : undefined);
      } else {
        var button = form.querySelector('button[type="submit"], input[type="submit"]');
        if (button) button.click();
        else form.submit();
      }
    }

    function holdForPhotos(submitter) {
      if (photoHold) return;
      photoHold = { submitter: submitter };
      var region = wrapper.querySelector('[data-form-feedback]');
      if (region) {
        region.textContent = '';
        var box = document.createElement('div');
        box.className = 'form-feedback form-feedback--pending pu-hold';
        var line = document.createElement('p');
        line.textContent = 'Sending your photographs...';
        var skip = document.createElement('button');
        skip.type = 'button';
        skip.className = 'pu-skip';
        skip.textContent = 'Send without photographs';
        skip.addEventListener('click', function () {
          form.fjbcPhotos.abandon();
          releasePhotoHold();
        });
        box.appendChild(line);
        box.appendChild(skip);
        region.appendChild(box);
      }
      form.fjbcPhotos.settled(releasePhotoHold);
    }

    /* Round 2 (photo CONTRACT section 6.4, Eli 2026-10-15), both forms, whatever the photo setting.
       The store's email prints every posted field, empty or not. */
    window.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      stampTimeZone(form);
      /* An empty campaign field gets its name back first, so campaign-source.js (a later submit
         listener) can still fill it; if it stays empty, the formdata step below drops it. */
      form.querySelectorAll('[data-campaign-field][data-campaign-name]').forEach(function (input) {
        if (!input.name) input.name = input.getAttribute('data-campaign-name');
      });
    }, true);
    /* On the form itself, so it runs after campaign-source.js has set the values. */
    form.addEventListener('formdata', function (event) {
      form.querySelectorAll('[data-campaign-field]').forEach(function (input) {
        if (!input.name || input.value) return;
        event.formData.delete(input.name);
        input.setAttribute('data-campaign-name', input.name);
        input.removeAttribute('name');
      });
    });

    window.addEventListener('submit', function (event) {
      if (event.target !== form || !form.fjbcPhotos) return;
      if (!photosPending()) {
        form.fjbcPhotos.write();
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      holdForPhotos(event.submitter);
    }, true);

    if (successful && pendingTimer) window.clearTimeout(pendingTimer);
    if (!successful) prefillEnquiry(wrapper);
  }

  function init() {
    document.querySelectorAll('[data-fjbc-contact-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
